// A locker stores a single BROKEN_LOCK code no matter which hardware broke, but
// the two hardwares fail — and are repaired — differently, so the faults views
// count them apart. The subtype comes from the locker's HardType in the matrix:
//
//   HardType 2 → pincho   (the default, and what a missing HardType means)
//   HardType 3 → slide / pestillo
//
// The split is derived at read time. Nothing writes BROKEN_LOCK_* anywhere: the
// device, the API and the faults collection all keep using plain BROKEN_LOCK.

export const HARD_TYPE_PINCHO = 2
export const HARD_TYPE_SLIDE = 3

export const BROKEN_LOCK_PINCHO = 'BROKEN_LOCK_PINCHO'
export const BROKEN_LOCK_PESTILLO = 'BROKEN_LOCK_PESTILLO'

// Fault code → Spanish label (same wording as the server PDF report)
export const FAULT_LABELS = {
  [BROKEN_LOCK_PINCHO]: 'Pincho roto',
  [BROKEN_LOCK_PESTILLO]: 'Pestillo roto',
  // Only reached by code that skips resolveFaultCode; resolution never leaves a
  // bare BROKEN_LOCK behind.
  BROKEN_LOCK: 'Pincho roto',
  GREEN_BLOCK: 'Pin verde no abre',
  RED_BLOCK: 'Pin rojo no abre',
  PINPAD_BLOCK: 'Teclado no enciende',
  PINPAD_ACTIVE: 'Teclado encendido',
  DOOR_BLOCK: 'Puerta no cierra',
}

/**
 * Split BROKEN_LOCK by the hardware of the locker that raised it; every other
 * code passes through untouched. An unknown HardType counts as a pincho, which
 * is both the Module default and how the modules views read a missing value.
 */
export function resolveFaultCode(faultCode, hardType) {
  if (faultCode !== 'BROKEN_LOCK') return faultCode

  return Number(hardType) === HARD_TYPE_SLIDE ? BROKEN_LOCK_PESTILLO : BROKEN_LOCK_PINCHO
}

/**
 * Label for a fault code. Unmapped codes keep their raw value so a new fault
 * type stays readable instead of silently collapsing into one row.
 */
export function faultLabel(faultCode) {
  return FAULT_LABELS[faultCode] || faultCode
}
